import * as echarts from 'echarts/core'
import {
    TooltipComponentOption,
    GridComponentOption,
    LegendComponentOption,
    MarkLineComponentOption,
} from 'echarts/components'
import { BarSeriesOption, PieSeriesOption } from 'echarts/charts'
export type EChartsOption = echarts.ComposeOption<
    | TooltipComponentOption
    | GridComponentOption
    | LegendComponentOption
    | MarkLineComponentOption
    | BarSeriesOption
    | PieSeriesOption
>;

// 堆叠图
export const stackedBarChartOption: EChartsOption = {
    toolbox: {
        itemSize: 24, // 设置图标大小为 24px（默认约 16px）
        feature: {
            saveAsImage: {
                name: 'my-chart', // 导出的文件名
                type: 'png', // 图片格式：png, jpeg, svg
                backgroundColor: 'transparent', // 背景色
                pixelRatio: 2, // 分辨率比例（提高清晰度）
                excludeComponents: ['toolbox'], // 排除工具栏自身
                title: 'export', // 悬停提示
                iconStyle: {
                    borderColor: '#036fc0', // 图标颜色
                    borderWidth: 1 // 图标描边宽度
                },
            },
        },
    },
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'shadow',
        },
    },
    legend: {},
    grid: {
        left: '10%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
    },
    xAxis: [
        {
            type: 'category',
            axisLabel: {
                rotate: 45
            },
            data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        },
    ],
    yAxis: [
        {
            type: 'value',
        },
    ],
    series: [
        {
            name: 'Email',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
                focus: 'series',
            },
            data: [120, 132, 101, 134, 90, 230, 210],
        },
        {
            name: 'Union Ads',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
                focus: 'series',
            },
            data: [220, 182, 191, 234, 290, 330, 310],
        },
        {
            name: 'Video Ads',
            type: 'bar',
            stack: 'Ad',
            emphasis: {
                focus: 'series',
            },
            data: [150, 232, 201, 154, 190, 330, 410],
        },
    ],
}

// 柱状图
export const barChartOption: EChartsOption = {
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'shadow',
        },
    },
    grid: {
        left: '10%',
        right: '4%',
        bottom: '3%',
        containLabel: true,
    },
    aria: {
        decal: {
            enabled: true,
            show: true,
            style: {
                textShadowBlur: 10,
                textShadowOffsetX: 0,
                textShadowColor: 'rgba(0,0,0,0.5)',
            },
        },
    },

    xAxis: {
        type: 'category',
        axisLabel: {
            rotate: 45,
        },
        data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    },
    yAxis: {
        type: 'value',
    },
    series: [
        {
            data: [120, 200, 150, 80, 70, 110, 130],
            type: 'bar',
        },
    ],
}

export const pieChartOption: EChartsOption = {
    aria: {
        decal: {
            enabled: true,
            show: true,
            style: {
                textShadowBlur: 10,
                textShadowOffsetX: 0,
                textShadowColor: 'rgba(0,0,0,0.5)',
            },
        },
    },
    // title: {
    //     text: 'Referer of a Website',
    //     subtext: 'Fake Data',
    //     left: 'center',
    // },
    tooltip: {
        trigger: 'item',
    },
    legend: {
        orient: 'vertical',
        left: 'left',
    },
    series: [
        {
            type: 'pie',
            radius: '50%',
            data: [
                { value: 1048, name: 'Search Engine' },
                { value: 735, name: 'Direct' },
                { value: 580, name: 'Email' },
                { value: 484, name: 'Union Ads' },
                { value: 300, name: 'Video Ads' },
            ],
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)',
                },
            },
        },
    ],
}
